import { Heart, Star, Sparkles, Sun } from "lucide-react";

const ITEMS = [
  { label: "Play", color: "#EF4444", Icon: Heart },
  { label: "Learn", color: "#3B82F6", Icon: Star },
  { label: "Grow", color: "#22C55E", Icon: Sparkles },
  { label: "Small Steps", color: "#F59E0B", Icon: Sun },
  { label: "Big Dreams", color: "#A855F7", Icon: Heart },
];

const Ribbon = () => (
  <div className="flex shrink-0 items-center">
    {[...ITEMS, ...ITEMS].map((item, i) => (
      <span key={i} className="flex items-center">
        <span
          className="font-display text-xl sm:text-2xl font-bold px-6 sm:px-8"
          style={{ color: item.color }}
        >
          {item.label}
        </span>
        <item.Icon className="h-5 w-5 fill-current" style={{ color: item.color }} />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="tagline-marquee"
    className="relative overflow-hidden border-y-4 border-white bg-gradient-to-r from-amber-100 via-rose-100 to-sky-100 py-4 -rotate-1 scale-105"
  >
    <div className="flex w-max animate-marquee">
      <Ribbon />
      <Ribbon />
    </div>
  </div>
);
